export const CHANGE_OPTION_RADIO_CONFIRMED = 'CHANGE_OPTION_RADIO_CONFIRMED';
export const CHANGE_DATES_PAYMENT          = 'CHANGE_DATES_PAYMENT';
export const CHECKED_PAYMENT_METHODS       = 'CHECKED_PAYMENT_METHODS';
export const GET_PAYMENTS_BY_FILTERS       = 'GET_PAYMENTS_BY_FILTERS';